import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "This is how lifestyle inflation snuck up on me",
  "description": "",
  "published": "2015-01-07T00:00:00.000Z",
  "redirect_from": ["/blog/this-is-how-lifestyle-inflation-snuck-up-on-me/swizec/6630"],
  "categories": "Adjusted gross income, Capital gain, Capital gains tax, Income tax, Long-Term Capital Management, Personal",
  "hero": "./img/images-25688.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "577px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/1ef48d621f288d7fcaa166ee80be638b/065e2/images-25688.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "68.60986547085201%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'275\\'%20viewBox=\\'0%200%20400%20275\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M271%209l-1%201c-3%200-2%204%200%205l2-1h5l1-1c0%201%201%202%204%202l4-1h5l1-1h1l1-1v1l1%201h1v1c2%200%202-2%201-3v-1c1-1-1-1-3-1-4%201-5%200-5-1%200-2-2-1-2%201h-2c-2-2-4-1-5%203-1%201-1%201-1-1%200-1-1-2-3-2l-4-1h-1M23%2037l-1%203c0%202%203%204%204%202h4c2-2%202-2%202%200h10c2%201%204-1%204-3s-3-4-4-2H31l-2-1v5l-1-2c0-1%200-2-1-1l-1%201v-1c0-2-2-3-3-1m303%2048a1282%201282%200%2001-156%20128L68%20236l-1%209v8h311l-1-69V40l-51%2045m-123%2023l9%205a3724%203724%200%200132%2015c5%202%205%202%203%207%200%202%200%202%206%202%209-1%209-2%204-8-4-6-5-7-5-4-1%203-4%203-6%201l-3-1h-1a380%20380%200%2000-39-17m-66%2070l11%2012%2010%2010-2%203c-3%203-3%203%205%204%207%202%208%202%207-1l-1-6c-1-6-2-7-5-4-2%203-2%203-14-10-9-8-12-11-11-8\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1ef48d621f288d7fcaa166ee80be638b/ca0a1/images-25688.webp 223w", "/static/1ef48d621f288d7fcaa166ee80be638b/75680/images-25688.webp 445w", "/static/1ef48d621f288d7fcaa166ee80be638b/d261b/images-25688.webp 577w"],
                "sizes": "(max-width: 577px) 100vw, 577px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1ef48d621f288d7fcaa166ee80be638b/e92b6/images-25688.png 223w", "/static/1ef48d621f288d7fcaa166ee80be638b/e66bf/images-25688.png 445w", "/static/1ef48d621f288d7fcaa166ee80be638b/065e2/images-25688.png 577w"],
                "sizes": "(max-width: 577px) 100vw, 577px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/1ef48d621f288d7fcaa166ee80be638b/065e2/images-25688.png",
                "alt": "My spending doubles every year",
                "title": "My spending doubles every year",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`My spending doubles every year`}</figcaption>{`
  `}</figure></p>
    <p>{`I never liked spending money. Splurging makes me twitch, expensive things make me uncomfortable, and if something costs more than €20, I better well use it every day until it dies. But four years ago the limit was 5 euro.`}</p>
    <p>{`And that's how lifestyle inflation creeps up when you least expect it.`}</p>
    <p>{`You work and you work, and money doesn't pile up. You make two times, three times, even four times as much as you used to, and the savings just aren't there.`}</p>
    <p>{`For the past three years I've been fortunate enough to do quite well for myself.`}</p>
    <p>{`My savings went from `}<em parentName="p">{`"Why is there so much month at the end of the money"`}</em>{` to `}<em parentName="p">{`"If I run out of work I'm proooobably going to be fine for a month or two"`}</em>{`.`}</p>
    <p>{`But that's not much savings even for a 27 year old. All of a sudden many of my friends are thinking about `}<em parentName="p">{`buying`}</em>{` real-estate, starting families, and becoming Real People (tm).`}</p>
    <p>{`And here I am, looking at the last four years of `}<a parentName="p" {...{
        "href": "http://toshl.com/"
      }}>{`Toshl`}</a>{` data in disbelief. I've built a habit of noting every cent I spend.`}</p>
    <p>{`It's horrifying.`}</p>
    <p>{`In the whole of 2011 I spent just €4,500. Living at home, sure. Mum paying most of my expenses, yes. Student life, nice and cheap.`}</p>
    <p>{`In 2014 I spent that much `}<em parentName="p">{`every month`}</em>{`. Every. Single. Month. It beggars belief.`}</p>
    <p>{`How the hell did I go from €4,500 per year to €60,000 per year in just four years? 1300% O.o`}</p>
    <p>{`Well, a few things `}<em parentName="p">{`have`}</em>{` changed.`}</p>
    <p>{`First of all, I'm no longer a student. In 2012 I started a company and began paying my fair share of taxes, welfare contributions, and pension. That's about a grand a month these days.`}</p>
    <p>{`Secondly, I moved out of my mum's place, spent a bunch of time abroad, and built a bit of a nomadic lifestyle. Rent was over 10,000 last year, plane tickets just over 2,200.`}</p>
    <p>{`That might seem cheap if you're reading from SF. But I assure you, it's quite steep when compared to nothing.`}</p>
    <p>{`My fixed expenses have gone from from €1,390 in 2012, to €18,740 in 2014. 1340%. Adulting is hard. :|`}</p>
    <p>{`But there's only so much I can do about that. I like being in SF as much as possible. Rent is high. If I want to afford the rent, I have to make more. That makes my taxes and welfare contributions go up as well.`}</p>
    <p>{`And then I have to make even more money. And more. And more. And suddenly I understand why it's called a rat race.`}</p>
    <p>{`Maybe I should switch to capital gains. But I don't have the money for capital gains. And I can't save up starting capital to switch to capital gains because the more I make, the more I spend.`}</p>
    <p>{`Poo.`}</p>
    <p>{`But maybe I should look at the €3,000 I spent in restaurants last year, the €2,000 I spent on sports, the €1,600 I spent on online services, the €1,000 I spent on taxis, the €1,400 I spent on partying, and certainly the €1,300 I spent on "misc".`}</p>
    <p>{`Man, that lifestyle inflation snuck up on me out of nowhere. Because what's a €20 here and a €20 there, right?`}</p>
    <p>{`And somewhere in the back of my mind I hear Mum screaming `}<em parentName="p">{`"Budgets!"`}</em>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      